import React from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Onboarding.css";
import Left from "./assets/Arrow---Left.svg";
import Leftt from "./assets/Grou63.svg";
import Lefttt from "./assets/sendeer.svg";
import Lef from "./assets/newsenfrtt.svg";
import Lefy from "./assets/lagaroo.svg";

const Onboarding = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate("/signup");
  };

  const settings = {
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <div className="onboarding">
      <Slider {...settings}>
        <div className="onboarding-slide">
          <div className="onboa">
            <div className="boardImage">
              <img
                src={Lef}
                alt="ijskkdf"
                style={{ width: "90%" }}
              />
            </div>

            <div className="onboabottomm" style={{ height: 256 }}>
              <div>
                <h1>
                  Welcome to UBS{" "}
                  <span style={{ color: "#0056b3" }}>Switzerland</span>
                </h1>
                <p>Manage your finances with ease and highlevel security.</p>
              </div>
              <div className="onboabottommmm">
                <div className="btnCover">
                  <button className="buttooi">
                    <img src={Left} alt="ijskkdf" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="onboarding-slide">
          <div className="onboa" style={{ paddingTop: "2%" }}>
          <div className="boardImage">
              <img src={Leftt} alt="ijskkdf" />
            </div>
            <div></div>
            <div className="onboabottomm" style={{ height: 229 }}>
              <div>
                <h1>
                  Save More With <span style={{ color: "#0056b3" }}>UBS</span>{" "}
                </h1>
                <p>
                  Set goals and achieve financial freedom with UBS, Meet yout
                  target with UBS
                </p>
              </div>
              <div className="onboabottommmm">
                <div className="btnCover">
                  <button className="buttooi">
                    <img src={Left} alt="ijskkdf" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="onboarding-slide">
          <div className="onboa">
          <div className="boardImage">
              <img
                src={Lefy}
                alt="ijskkdf"
                style={{ width: "100%" }}
              />
            </div>

            <div className="onboabottomm" style={{ height: 259 }}>
              <div>
                <h1>Track Your Expenses</h1>
                <p>
                  Get detailed insights into your spending habits, UBS
                  algorithms are trained for your success.
                </p>
              </div>
              <div className="onboabottommmm">
                <div className="btnCover">
                  <button className="buttooi">
                    <img src={Left} alt="ijskkdf" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="onboarding-slide">
          <div className="onboa" >
          <div className="boardImage">
              <img
                src={Lefttt}
                alt="ijskkdf"
                style={{ width: "100%" }}
              />
            </div>
            <div>
              <h1>Get Started Now</h1>
              <p>
                Join us and take control of your finances, your Expenses, Income
                and Spending habbits.
              </p>
            </div>
            <div className="onboabottomm">
              <div className="onboabottom">
                <button className="buttooii" onClick={handleGetStarted}>
                  Get Started <img src={Left} alt="ijskkdf" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </Slider>
    </div>
  );
};

export default Onboarding;
